import React from 'react';
import { Button } from 'antd';
import styled from 'styled-components';

const Container = styled.div`
  box-sizing: border-box;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 40px;
  background-color: rgb(255 255 255 / 95%);
  z-index: 9;
  height: calc(100vh - 60px);
  opacity: 0.9;
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: 500;
  color: #262626;
  margin-bottom: 32px;
  text-align: center;
  line-height: 1.5;
  max-width: 500px;
`;

const ContactButton = styled(Button)`
  padding: 8px 24px;
  height: auto;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  border-color: #d9d9d9;
  color: #595959;

  &:hover {
    border-color: #40a9ff;
    color: #40a9ff;
  }

  &:focus {
    border-color: #40a9ff;
    color: #40a9ff;
  }
`;

/**
 * ContactConviva Component
 *
 * Displays a message asking users to contact their Conviva representative
 * with a button that navigates to the support page.
 */
const ContactConviva: React.FC = () => {
  const handleContactClick = () => {
    // Navigate to the support page
    window.location.href = '/app/pulse/support';
  };

  return (
    <Container>
      <Title>Please contact your Conviva representative to activate</Title>
      <ContactButton onClick={handleContactClick}>Contact Conviva</ContactButton>
    </Container>
  );
};

export default ContactConviva;
